import React from 'react';

/**
 * SmoothScroll mock component
 * This component acts as a pass-through container for children, maintaining build compatibility.
 * If you had smooth momentum scrolling, you can restore its original code from VS Code Local History.
 */
const SmoothScroll = ({ children }) => {
    return <>{children}</>;
};

export default SmoothScroll;
